import { useState, useEffect } from 'react';

const TICK_INTERVAL = 0.25;

/**
 * An imprecise timer that uses timeouts to fire a callback at a fixed interval
 */
export const useTimer = ({ fireSeconds, onFire }) => {
  const [timer, setTimer] = useState(fireSeconds);

  useEffect(() => {
    if (timer <= 0) {
      onFire();
      setTimer(fireSeconds);
    }

    const refreshFire = setTimeout(() => setTimer((t) => t - TICK_INTERVAL), TICK_INTERVAL * 1000);
    return () => clearTimeout(refreshFire);
  }, [timer]);
};

const now = () => new Date().getTime();

/**
 * An idle detector, fire the activity() callback on user input
 */
export const useIdleDetector = ({ thresholdSeconds }) => {
  const [last, setLast] = useState(now());

  const timeIdle = now() - last;
  const isIdle = timeIdle > thresholdSeconds * 1000;
  const activity = () => setLast(now());
  return [isIdle, activity];
};
